var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"phone"},_vm._l((_vm.formList),function(item,index){return _c('div',{key:index,staticClass:"section"},[_c(_vm.componentNames[item.moduleValue],{tag:"component",attrs:{"itemData":item,"title":_vm.title,"activityUrl":_vm.activityUrl}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }